module.exports = __webpack_public_path__ + "static/media/warning-circle-white.3d1ae0be.svg";